import { stringToInteger } from "./browser-utils";

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;

export const minutesToDays = (minutes) => {
  const days = Math.floor(minutes / 60 / 24);
  if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""}`;
  }
  return;
};

export const formatTimeToHHMMSS = (timeInSeconds) => {
  const seconds = stringToInteger(timeInSeconds);

  if (!seconds) {
    return "";
  }

  const hours = Math.floor(seconds / SECONDS_IN_HOUR);
  const mins = Math.floor((seconds % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
  const secs = seconds % SECONDS_IN_MINUTE;

  const pad = (val) => String(val).padStart(2, "0");
  return `${pad(hours)}:${pad(mins)}:${pad(secs)}`;
};
